import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Logout",
  "use": "Logout-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"Logout\">\n  <path d=\"m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5ZM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol